import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

type Props = {
  onDeletar: (idBiometriaFacial: number) => void;
  onActionVisualize: (idBiometriaFacial: number) => void;
  onActionAuditoria: (auditId: string) => void;
};

export const GenerateBiometriaFacialColumnsDefinition = ({
  onDeletar,
  onActionVisualize,
  onActionAuditoria,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case false:
        return "Inativo";
      case true:
        return "Registrado";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case false:
        return "red";
      case true:
        return "green";
      default:
        return "blue";
    }
  };
  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
      case false:
        return "Biometria inativo";
      case true:
        return "Biometria ativo";
      default:
        return "?";
    }
  };
  return [
    {
      field: "Data",
      headerName: "Data Cadastro",
      width: 130,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center justify-start text-xs py-2 px-2">
          <span>
            {params.value && dayjs(params.value).format("DD/MM/YYYY")}
          </span>
        </div>
      ),
    },
    {
      field: "Hora",
      headerName: "Hora Cadastro",
      width: 120,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center justify-start text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "NomeCadastradoPor",
      headerName: "Cadastrado Por",
      flex: 1,
      minWidth: 180,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className="break-words whitespace-normal w-full h-full flex items-center justify-start text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "Ativo",
      headerName: "Biometria",
      width: 120,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            textSize="small"
            size="autowidth"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "visualizar",
      filterable: false,
      headerName: "Visualizar",
      width: 175,
      sortable: false,
      resizable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const maxSize = 20;
        const arquivoNome = "Imagem de Biometria";

        const idBiometriaFacial = row.IdBiometriaFacial as number;

        return (
          <div className="w-full h-full flex items-center justify-center text-center text-xs py-2">
            <Button
              onMouseDown={() => onActionVisualize(idBiometriaFacial)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}
            >
              {arquivoNome && arquivoNome.length > maxSize
                ? `${arquivoNome.substring(0, maxSize)}...`
                : arquivoNome}
            </Button>
          </div>
        );
      },
    },
    {
      field: "auditId",
      filterable: false,
      headerName: "Termo",
      width: 130,
      sortable: false,
      resizable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const auditId = row.AuditId || row.auditId;
        if (!auditId) {
          return (
            <div className="w-full h-full flex items-center justify-center"></div>
          );
        }
        const maxSize = 20;
        const arquivoNome = "Ver Termo";

        return (
          <div className="w-full h-full flex items-center justify-center text-center text-xs py-2">
            <Button
              onClick={() => onActionAuditoria(auditId)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}
            >
              {arquivoNome && arquivoNome.length > maxSize
                ? `${arquivoNome.substring(0, maxSize)}...`
                : arquivoNome}
            </Button>
          </div>
        );
      },
    },
    {
      field: "acoes",
      filterable: false,
      headerName: "Ações",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const inativo = !row.Ativo;

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => onDeletar(row.IdBiometriaFacial)}
              disabled={inativo}
            >
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className={inativo ? "text-gray-400" : "text-red-500"}
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
